import type { ArticleDetailApiData, ArticleDetailApi } from '~/server/types'

export const useArticleStore = defineStore('Article', () => {
  const { config } = storeToRefs(useStore())
  const articleDetail = ref<ArticleDetailApiData>()

  const throwArticleRequestError = (error?: { statusCode?: number; statusMessage?: string } | null) => {
    const statusCode = error?.statusCode || 404
    const statusMessage = error?.statusMessage || 'Page Not Found'

    if (import.meta.client) {
      showError({
        statusCode,
        statusMessage
      })
      return
    }

    throw createError({
      statusCode,
      statusMessage
    })
  }

  async function fetchArticleDetail(id: number) {
    const res = await useFetch(`/api/article/detail?id=${id}`)
    if (res.error.value) {
      throwArticleRequestError(res.error.value)
    }
    if (!res.data.value?.data) {
      throwArticleRequestError()
    }
    articleDetail.value = (res.data.value as ArticleDetailApi).data
    return articleDetail.value
  }
  async function fetchArticleList(
    rule: number,
    page: number,
    size: number,
    type: 'default' | 'category' | 'all' = 'default',
    categoryId: string | number = -1
  ) {
    const res = await useFetch(
      `/api/article/list?lang_id=${config.value.id}&rule=${rule}&page=${page}&size=${size}&type=${type}&category_id=${categoryId}`
    )
    if (res.error.value) {
      throwArticleRequestError(res.error.value)
    }
    if (!res.data.value?.data) {
      throwArticleRequestError()
    }
    return res.data.value.data
  }
  return {
    articleDetail,
    fetchArticleDetail,
    fetchArticleList
  }
})
